import { render, staticRenderFns } from "./chooseOrder.vue?vue&type=template&id=abaf8896&scoped=true"
import script from "./chooseOrder.vue?vue&type=script&lang=js"
export * from "./chooseOrder.vue?vue&type=script&lang=js"
import style0 from "./chooseOrder.vue?vue&type=style&index=0&id=abaf8896&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abaf8896",
  null
  
)

export default component.exports